module.exports = __webpack_public_path__ + "img/20200106165102360截图20200106105358877.912ed2c6.jpg";